module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAaCAYAAADWm14/AAAAAXNSR0IArs4c6QAAASZJREFUSA3tl8FKw0AQQGc2UChtbBK8pAe39hJKfkHwA/oN1lsvfoBQxENF/A/BPxCvCl79hrgRqZceDCqhlmacCeTmNXvauUx2WfJmHnuYxTRNO18/5RKpmhFADBYCAT4I1a3f61563Z5/DVSdM9e3wG4QzKKj3+2ug1qPVtI5gprmefbQnGgz6/F4SrvqXkzggR4xH+AtN7y2Fw1X2UP+T3IFOAPOgDPgDDgDzoAzoGQsklFBTyZWBlJhJUkylMyxUoT4Il9UljPJNqLcbE5qDrO9KAzfieAUEY8HQbAN4jgr1uvvNgoRy4N+/wwBl/x/9BTO60FU68MFAV3xpq1LWSlUF8ZkN550WhSfz1EUPhLgPle0x1utvBHq+4b4JJ0b83on7D9k2E2zhoj5xgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/check-in-expanded-01-copy-10-shape-9@2x.png
// module id = 94
// module chunks = 0